import FeaturesGrid from "../../components/FeaturesGrid";
import PlatformBenefits from "../../components/PlatformBenefits";
import LoginForm from "../../components/LoginForm";

const Login = () => {
  return (
    <>
      <div className="max-w-7xl mx-auto py-12 px-8 flex flex-col lg:flex-row gap-16 min-h-[calc(100vh-200px)]">
        <LoginForm />

        <section className="flex-1 flex flex-col gap-8">
          <div className="mb-4">
            <h2 className="text-4xl font-bold text-[#586989] mb-4 leading-tight">
              Business Automation for
              <br />
              Short Term Rental Changeover Management
            </h2>
            <p className="text-gray-700 text-lg font-medium leading-relaxed">
              HouseKeeper eliminates 2-3 hours of weekly admin work through
              intelligent automation. More than a task manager—it's your
              complete changeover operations platform.
            </p>
          </div>

          <FeaturesGrid />
          <PlatformBenefits />
        </section>
      </div>
    </>
  );
};

export default Login;
